import { AppImages } from "../constants/imageConstants";
import { Button, Box, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";

const PageNotFound = () => {
  const navigate = useNavigate();

  return (
    <Stack
      direction={"column"}
      justifyContent={"center"}
      alignItems={"center"}
      bgcolor={"background.paper"}
      height={"100vh"}
    >
      <Box sx={{ height: { xs: 200, sm: 300, md: 400 } }}>
        <img
          src={AppImages.error404}
          height={"100%"}
          width={"100%"}
          alt="404 page "
          style={{ objectFit: "contain" }}
        />
      </Box>
      <Typography
        variant="h2"
        fontWeight={500}
        color="text.disabled"
        gutterBottom
      >
        OOPS! PAGE NOT FOUND
      </Typography>

      <Typography
        gutterBottom
        variant="subtitle1"
        color="text.secondary"
        sx={{ width: "50%", textAlign: "center", fontWeight: 500 }}
      >
        You must have picked the wrong door because I haven&apos;t been able to
        lay my eye on the page you&apos;ve been searching for.
      </Typography>
      <Button
        variant="contained"
        color="button"
        onClick={() => navigate("/login")}
        startIcon={<KeyboardBackspaceIcon size={15} />}
      >
        Go Back To Home
      </Button>
    </Stack>
  );
};

export default PageNotFound;
